$(document).ready(function() {
	fetch('/browsing_context_suggestions.json').then(function (res) {
		return res.json()
	}).then(function (data) {
		if(data && (data.detected_values.country.handle === 'US'
							 || data.detected_values.country.handle === 'GB')){
			$('.template-product .ProductForm__ReturnLink').show();
		}
	})
	

	if( typeof(productOptions ) != "undefined" ){
		for(i=0;i<productOptions.length;i++) {
			$('.single-option-selector:eq('+ i +')')
			.filter(function() {
				return $(this).find('option').length > 1
			})
			.prepend('<option value="">Pick a ' + productOptions[i][i] + '</option>')
			.val('')
			.trigger('change');
		}
	}


	// Slider code
	var $materialsDiscoverSlider = $('.Product__Slideshow').flickity({
		wrapAround: false,
		autoplay:true,
		prevNextButtons: true,
		pageDots: true,
		adaptiveHeight: true,
		draggable:true,
		freeScroll: false,
		contain: true
	});

	$('.Product__Slideshow').append(' <div class="carousel-tracker"><span class="carousel-tracker-bar"></span></div>');

	$materialsDiscoverSlider.on( 'scroll.flickity', function( event, progress ) {
		//progress = Math.max( 0, Math.min( 1, progress ) );
		// $progressBar.width( progress * 100 + '%' );
		//console.log(event,progress);
		carouselProgress();

	});



	function carouselProgress(){
		var $slide_width;
		var $slideNumber = ($(".Product__Slideshow.bottom .Product__SlideItem").length);
		var $leftBlock = 100 / $slideNumber;
		$slide_width = $leftBlock + '%';
		$('.Product__Slideshow.bottom ol.flickity-page-dots').find('.Product__Slideshow.bottom li.dot.is-selected').css( 'width', $slide_width);

		// $(this).find('.Product__Slideshow.bottom .flickity-page-dots');
		var currentIndex = $('.Product__Slideshow.bottom ol li.dot.is-selected').index();
		var $newLeftVal = $slideNumber*$leftBlock *(currentIndex) + '%';
		$slide_width = $leftBlock + '%'

		$('.carousel-tracker-bar ').css( 'transform' , 'translateX('+$newLeftVal+')' );
		$('.carousel-tracker-bar ').css( 'width', $slide_width);


	}


	setTimeout(function(){
		function RecomendProgress(){
			var $slide_width;
			var $slideNumber = ($(".bottom-like-more .Carousel__Cell").length);
			var $leftBlock = 100 / $slideNumber;
			$slide_width = $leftBlock + '%';
			$('.bottom-like-more ol.flickity-page-dots').find('.bottom-like-more li.dot.is-selected').css( 'width', $slide_width);

			// $(this).find('.Product__Slideshow.bottom .flickity-page-dots');
			var currentIndex = $('.bottom-like-more ol li.dot.is-selected').index();
			var $newLeftVal = $slideNumber*$leftBlock *(currentIndex) + '%';
			$slide_width = 20 + '%'

			$('.carousel-tracker-bar ').css( 'transform' , 'translateX('+$newLeftVal+')' );
			$('.carousel-tracker-bar ').css( 'width', $slide_width);


		}

		var recomendationSlider = $('.bottom-like-more').flickity({
			wrapAround: false,
			autoplay:true,
			prevNextButtons: true,
			pageDots: true,
			adaptiveHeight: true,
			draggable:true,
			freeScroll: false,
			contain: true,
			groupCells: true
		});

		$('.bottom-like-more').append(' <div class="carousel-tracker"><span class="carousel-tracker-bar"></span></div>');

		recomendationSlider.on( 'scroll.flickity', function( event, progress ) {
			//console.log(event,progress);
			RecomendProgress()

		});
	}, 2000);

	// End slider code

});

function myFunction() {
	setTimeout(function(){

		$('h2.Footer__Title.Heading.u-h6').click(function() {
			$(this).toggleClass('active');
			$(this).parent('.Footer__Block').toggleClass('active');
		});
	}, 3000);
}

let productSectionSettings = $("[data-section-id='product-template']").data("section-settings");

if($("body").hasClass("template-product") && productSectionSettings.hideDefaultVariant) {

	$(document).on("click", ".ProductForm__AddToCart[type=button]", function(e) {
		e.preventDefault();

		let $form = $(this).closest("form");;

		let variantId = $form.find('[name="id"]').val();
		if(variantId) {

			$(this).attr("type", "submit");
		} else {

			$form.find(".cart_add_error").removeClass("hide");

		}

	});
}

$(document).on("click", ".chat-now", function(e) {
	e.preventDefault();
	if(window.lc_agent_available && typeof LC_API !== 'undefined') {
		zE.hide();
		window.LC_API.open_chat_window();
		return false;
	}
});

$(document).on("click", "button.email-now.open-widget", function(e) {
	e.preventDefault();
	if(typeof LC_API !== 'undefined') {
		LC_API.hide_chat_window();
	}
	zE.activate({hideOnClose: true});
});


// Sticky cart button
$( document ).ready( function(){
	var $cartBtnWrapper = $('.template-product .cart-btn-wrapper');
	if($('section.Product').hasClass("enable-sticky")){
		$.fn.isInViewport = function() {
			didScroll = true;
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + ($(this).outerHeight() - $(this).innerHeight() - 0);
			var viewportTop = $(window).scrollTop() - 50 ;
			var viewportBottom = viewportTop + $(window).height() + 80;
			return elementBottom > viewportTop && elementTop < viewportBottom;
		};


		function controlStickyCartBtn() {
			if (!$cartBtnWrapper.isInViewport() && !$cartBtnWrapper.find(':submit.ProductForm__AddToCart').is(":disabled")) {
				$cartBtnWrapper.addClass('cartBtnStickyHeightFixActive');
			} else {
				$cartBtnWrapper.removeClass('cartBtnStickyHeightFixActive');
			}
		}

		//controlStickyCartBtn();
		$(window).on('resize scroll', function() {
			controlStickyCartBtn();
		});
	}
});

// First product tab active
$(document).ready(function() {
	$(function() {
		$(".Product__Tabs [data-action='toggle-collapsible']:first").click()
	})
});

$(document).on('click', '.ControlBar__btn', function(){
	$('.control-bar-filters').addClass('show-control-bar');
	$('.control-bar-filters').addClass('transitioning');
});

$(document).on('click', '.ControlBar__close-btn', function(){
	$('.control-bar-filters').removeClass('show-control-bar');
  setTimout(function(){
	$('.control-bar-filters').removeClass('transitioning');
  }, 500);
});

$('.Footer__Title').click(function() {
  $(this).toggleClass('active');
  $(this).parent('.Footer__Block').toggleClass('active');
});

$(document).on('click', '.ig-preview-image', function(){
	var $this = $(this),
	$image = $this.data('image-url'),
	$link = $this.data('url');
	$('.ig-popup-container').show();
	$('.ig-popup-image img').attr('src', $image);
	$('.ig-popup-actions a').attr('href', $link);
});

$(document).on('click', '.ig-popup-close', function(){
	$('.ig-popup-container').hide();
});